<template>
  <page-header :title="id?title:titleNew" :icon="icon" :back="true"/>
  <f-loader ref="loader">
    <f-form
        ref="form"
        :new-mode="!id"
        :no-edit="noEdit"
        :no-delete="noDelete"
        :back-button="backButton || 'К списку'"
        @form-delete="onFormDelete"
        @form-send="onFormSend"
    >
      <template v-slot:default="form">
        <slot :edit="form.edit"/>
      </template>
      <template v-slot:actions="form">
        <slot name="actions" :edit="form.edit"/>
      </template>
    </f-form>
  </f-loader>
</template>

<script>
import PageHeader from "@/components/PageHeader";
import {http} from "@/misc/http";
import FForm from "@/components/FForm";
import FLoader from "@/components/FLoader";

export default {
  components: {FLoader, FForm, PageHeader},
  props: [
    "id",
    "item",
    "identity",

    "url",
    "resource",

    "icon",
    "titleNew",
    "title",

    "beforeSend",
    "beforeDelete",

    "noEdit",
    "noDelete",

    "backButton",
  ],


  async mounted() {
    if (this.id) {
      await this.$refs.loader.wrap(async () => {
        Object.assign(this.item, await http.get(this.url + '/' + this.id));
      });
    }
  },

  methods: {
    async wrap(f) {
      return await this.$refs.loader.wrap(f);
    },

    async onFormSend() {
      await this.$refs.loader.wrap(async () => {
        if (this.beforeSend && !await this.beforeSend()) return;
        Object.assign(this.item, await http[this.id ? "put" : "post"](this.url, this.item));
        this.$refs.form.accept();
        this.$router.replace({name: this.resource, params: {[this.identity]: this.item[this.identity]}});
      });
    },

    async onFormDelete() {
      await this.$refs.loader.wrap(async () => {
        if (this.beforeDelete && !await this.beforeDelete()) return;
        await http.delete(this.url + "/" + this.id);
        this.$router.go(-1);
      });
    },

  },


}
</script>
